import { render, staticRenderFns } from "./EditorBlockSettings.vue?vue&type=template&id=560b7f24"
import script from "./EditorBlockSettings.vue?vue&type=script&lang=js"
export * from "./EditorBlockSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports